import React, { ReactNode } from 'react';
import { usePage } from '@inertiajs/react';
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment } from '@fortawesome/pro-regular-svg-icons';
import Valuation from '../../Data/Valuation';
import AuthedLayout from '../../Layouts/Authed';
import ValuationCtaCard from '../../Components/Dashboard/ValuationCtaCard';
import PreparationChecklistCard from '../../Components/Dashboard/PreparationChecklistCard';
import ValuationsTableCard from '../../Components/Dashboard/ValuationsTableCard';

interface Props {
	valuations: Valuation[];
}

const UserHome = (props: Props) => {
	const { user } = usePage<any>().props;
	const firstName = user?.name?.split(' ')[0] ?? 'there';

	const inProgressValuation = props.valuations.find(
		(v) => v.status === 'In Progress'
	);

	return (
		<div>
			<p className='mb-5'>
				<FontAwesomeIcon icon={faComment} className='me-2' />
				Welcome back, <strong>{firstName}</strong>!
			</p>

			<Row className='g-4'>
				<Col lg={9}>
					<ValuationCtaCard inProgressValuation={inProgressValuation} />
					<div className='d-lg-none mt-4'>
						<PreparationChecklistCard />
					</div>
					<div className='mt-4'>
						<ValuationsTableCard valuations={props.valuations} />
					</div>
				</Col>
				<Col lg={3} className='d-none d-lg-block'>
					<PreparationChecklistCard />
				</Col>
			</Row>
		</div>
	);
};

UserHome.layout = (page: ReactNode) => <AuthedLayout pageTitle="Your Dashboard">{page}</AuthedLayout>;

export default UserHome;
